import { LayoutComponent } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 5,
        rows: 3,
        rowsSize: [0, 0, 0],
        colsSize: [1, 0, 0, 0, 1],
        colSpan: {
          "0:1": 3,
        },
        gap: "30px",
        components: [
          [
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data:
                      "A set of (psycho-)acoustic analysis methods can be identified to characterize the relevant patterns within the sound recordings and can be used as predictors in the process of Sound Quality Metric Development.",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 600,
                      width: "600px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                },
              },
            },
          ],
          [
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide05-sound-image01.svg`,
                    styles: {
                      width: "230px",
                      height: "290px",
                    },
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide05-sound-image02.svg`,
                    styles: {
                      width: "230px",
                      height: "290px",
                    },
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide05-sound-image03.svg`,
                    styles: {
                      width: "230px",
                      height: "290px",
                    },
                  },
                },
              },
            },
          ],
          [
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/02/case01/slide05-sound1.wav`,
                    text: "SQ  = 9.09",
                    icon: "cis-volume-high",
                    theme: "secondary",
                    shape: "round",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/02/case01/slide05-sound2.wav`,
                    text: "SQ  = 9.88",
                    icon: "cis-volume-high",
                    theme: "secondary",
                    shape: "round",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    url: `${config.ASSETS_URL}/02/case01/slide05-sound3.wav`,
                    text: "SQ  = 7.66",
                    icon: "cis-volume-high",
                    theme: "secondary",
                    shape: "round",
                  },
                },
              },
            },
          ],
        ],
      },
      styles: {
        borderBottom: `solid 1px ${variables["default-light"]}`,
      },
    },
  },
];

export default components;
